import type { ReactNode } from 'react';
import { cn } from '@/shared/utils/cn';

const WIDTHS = { default: 'max-w-[1200px]', narrow: 'max-w-3xl', form: 'max-w-md' } as const;

export interface PageContainerProps {
  children: ReactNode;
  width?: keyof typeof WIDTHS;
  className?: string;
}

/** Columna de contenido: máx. 1200 px, gutters 16/24/32 y aire vertical consistente. */
export function PageContainer({ children, width = 'default', className }: PageContainerProps) {
  return (
    <div
      className={cn('mx-auto w-full px-4 py-6 md:px-6 md:py-8 lg:px-8', WIDTHS[width], className)}
    >
      {children}
    </div>
  );
}
